export default __webpack_public_path__ + "static/media/fileupload.faafc271.svg";